angular.module('impactx.list').directive("ixResetAllFilters", ResetAllFilters);

ResetAllFilters.$inject = ['$listCache'];

function ResetAllFilters($listCache) {
    return {
        scope: {
            listId: '=',
            serverSideList: "="
        },
        restrict: 'EA',
        require: '^stTable',
        link: function (scope, element, attrs, ctrl) {
            return element.bind('click', function () {
                return scope.$evalAsync(function () {
                    var popupFilters = scope.$parent.$parent.data.popupFilters;
                    for (var i = 0; i < popupFilters.length; i++)
                    {
                        for (var l = 0; l < popupFilters[i].filterField.entries.length; l++)
                        {
                            popupFilters[i].filterField.entries[l].selected = false;
                        }

                    }
                    var autoCompleteFilters = scope.$parent.$parent.data.autoCompleteFilters;
                    for (var j = 0; j < autoCompleteFilters.length; j++)
                    {
                        autoCompleteFilters[j].searchText = '';
                    }
                    var booleanFilters = scope.$parent.$parent.data.booleanFilters;
                    for (var k = 0; k < booleanFilters.length; k++)
                    {
                        booleanFilters[k].selected = false;
                    }
                    var stringFilters = scope.$parent.$parent.data.headers;
                    for (var m = 0; m < stringFilters.length; m++)
                    {
                        stringFilters[m].value = '';
                    }
                    var tableState;
                    tableState = ctrl.tableState();
                    tableState.search.predicateObject = {};
                    tableState.pagination.start = 0;
                    $listCache.remove(scope.listId);
                    if (!scope.serverSideList && scope.$parent.$parent.data.deprecatedFilter)
                    {
                        ctrl.search(ctrl.search(true, scope.$parent.$parent.data.deprecatedFilter.filterField));
                    }
                    return ctrl.pipe();
                });
            });
        }
    };
}
